import { t, type StringKey } from '../strings';

/**
 * 🔒 The words a confidential field's disclosure row reads as on the Security
 * page (decision 1397; T582, proposal C5), kept beside the record and field
 * that key it (decision 0472: a machine identifier is never drawn as a label).
 * 🔨 A row this list does not name reads as a sentence saying it has no label,
 * never as its own identifiers; a test holds every seeded row to a label.
 */
export const CONFIDENTIAL_FIELD_LABELS: Readonly<Record<string, StringKey>> = {
  'CompanyRecord.ein': 'settings.security.disclosure.companyEin',
  'VendorTaxProfile.tin': 'settings.security.disclosure.vendorTin',
};

/** The words a disclosure row reads as, from the list above. */
export function confidentialFieldLabel(entity: string, field: string): string {
  const key = CONFIDENTIAL_FIELD_LABELS[`${entity}.${field}`];
  return t(key ?? 'settings.security.disclosure.unnamed');
}
